import {
  ServiceLocation,
  ServiceLocationAddress,
  ServiceLocationLink,
  ServiceLocationLocation,
  ServiceLocationPhone,
  ServiceLocationType,
} from "../models";

export const isServiceLocationLocation = (
  loc: ServiceLocation
): loc is ServiceLocationLocation => loc.type === ServiceLocationType.LOCATION;

export const isServiceLocationPhone = (
  loc: ServiceLocation
): loc is ServiceLocationPhone => loc.type === ServiceLocationType.PHONE;

export const isServiceLocationAddress = (
  loc: ServiceLocation
): loc is ServiceLocationAddress => loc.type === ServiceLocationType.ADDRESS;

export const isServiceLocationLink = (
  loc: ServiceLocation
): loc is ServiceLocationLink => loc.type === ServiceLocationType.LINK;
